import cx from 'classnames'
import React from 'react'

import Icon from '@f/elements/Icon'

interface ValidationLoaderProps {
  isDataValidation: boolean
  isAccountCreation: boolean
  secondLoaderConfig: {
    label: string
    icon: string
  }
}

export const ValidationLoader = ({
  isDataValidation,
  isAccountCreation,
  secondLoaderConfig
}: ValidationLoaderProps) => {
  return (
    <TransitionLoaderContainer>
      {isDataValidation && (
        <TransitionLoader
          label={'Anfrage wird gespeichert'}
          icon={'lock-16px'}
        />
      )}
      {isAccountCreation && (
        <TransitionLoader
          label={secondLoaderConfig?.label}
          icon={secondLoaderConfig?.icon}
        />
      )}
    </TransitionLoaderContainer>
  )
}

const TransitionLoaderContainer = ({
  children
}: {
  children: React.ReactNode
}) => {
  return (
    <div className='[ f-overflow f-c-ba-bac025 ] QuizApp-transition'>
      <div className='[ f-m-v-050 f-m-h-auto f-p-v-050 f-p-h-020 ] QuizApp-transition-fadeIn'>
        <div className='[ f-d-flr f-fl-jc-ce ]'>{children}</div>
      </div>
    </div>
  )
}

const TransitionLoader = ({ label, icon }: { label: string; icon: string }) => {
  return (
    <div className={cx('[ f-fl-al-ce ] QuizApp-transition-ring-wrap')}>
      <div className='[ f-pos-rel ] QuizApp-transition-ring is-animating'>
        <svg className='QuizApp-transition-ring-svg'>
          <circle cx='150' cy='150' r='140'></circle>
          <circle cx='150' cy='150' r='140'></circle>
        </svg>
        <Icon
          icon={icon}
          className='[ f-icon-120 f-c-st-pri f-pos-ab ] QuizApp-transition-ring-icon'
        />
      </div>
      <span className='[ f-t-tminor f-t-centre f-c-fo-pri ] QuizApp-transition-ring-text'>
        {label}
      </span>
    </div>
  )
}
